import React from "react";
import styled from "styled-components";

import img1 from "../assets/Images/vim_temp.jpg";
import img3 from "../assets/Images/vim_temp.jpg";

const Section = styled.section`
  position: relative;
  min-height: 100vh;
  width: 80vw;
  display: flex;

  margin: 0 auto;

  @media (max-width: 48em) {
    width: 90vw;
  }
  @media (max-width: 30em) {
    width: 100vw;
  }
`;
const Title = styled.h1`
  font-size: ${(props) => props.theme.fontBig};
  font-family: "Kaushan Script";
  font-weight: 300;

  position: absolute;
  top: 1rem;
  left: 5%;
  z-index: 5;

  @media (max-width: 64em) {
    font-size: ${(props) => `calc(${props.theme.fontBig} - 5vw)`};
    top: 0;
    left: 0;
  }
  @media (max-width: 48em) {
    font-size: ${(props) => props.theme.fontxxxl};
  }
`;
const Left = styled.div`
  width: 50%;
  font-size: ${(props) => props.theme.fontlg};
  font-weight: 300;
  position: relative;
  z-index: 5;
  margin-top: 15%;
  padding-top: 3rem;
  display: flex;
  flex-direction: column;
  padding-right: 2rem;

  @media (max-width: 64em) {
    width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) !important;
    margin: 0 auto;
    padding: 2rem;
    font-weight: 600;

    backdrop-filter: blur(2px);
    background-color: ${(props) => `rgba(${props.theme.textRgba},0.4)`};
    border-radius: 20px;
    z-index: 2; // Reduced z-index for mobile view
  }

  @media (max-width: 48em) {
    font-size: ${(props) => props.theme.fontmd};
  }
  @media (max-width: 30em) {
    font-size: ${(props) => props.theme.fontsm};
    width: 70%;
  }
`;

const TextContent = styled.div`
  flex: 0 1 auto;
`;

const ProfileButton = styled.a`
  display: inline-block;
  margin-top: 2rem;
  padding: 0.8rem 2rem;
  background-color: ${(props) => props.theme.text};
  color: ${(props) => props.theme.body};
  font-size: ${(props) => props.theme.fontmd};
  font-weight: 600;
  text-decoration: none;
  border-radius: 50px;
  border: 2px solid ${(props) => props.theme.text};
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  z-index: 10;
  width: fit-content;

  &:hover {
    background-color: ${(props) => props.theme.body};
    color: ${(props) => props.theme.text};
  }

  @media (max-width: 48em) {
    font-size: ${(props) => props.theme.fontsm};
    padding: 0.6rem 1.5rem;
  }
`;

const Right = styled.div`
  width: 50%;
  position: relative;
  img {
    width: 100%;
    height: auto;
  }

  .small-img-1 {
    width: 40%;
    position: absolute;
    right: 95%;
    bottom: 10%;
  }
  .small-img-2 {
    width: 40%;
    position: absolute;
    left: 80%;
    bottom: 30%;
  }

  @media (max-width: 64em) {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 100vh;
      object-fit: cover;
    }
    .small-img-1 {
      width: 30%;
      height: auto;
      left: 5%;
      bottom: 10%;
      z-index: 3; // Higher z-index to overlap text
    }
    .small-img-2 {
      width: 30%;
      height: auto;
      left: 60%;
      bottom: 20%;
      z-index: 3; // Higher z-index to overlap text
    }
  }
`;

const VIMAL = () => {
  return (
    <Section id="fixed-target" className="about">
      <Title
        data-scroll
        data-scroll-speed="-2"
        data-scroll-direction="horizontal"
      >
        Vimalraj
      </Title>
      <Left data-scroll data-scroll-target="#fixed-target">
        <TextContent>
          I'm a full-stack developer, based in VILUPURAM, who
          specializes in building robust web technologies.
          <br />
          <br />
          I am dedicated to engineering high-performance applications, from
          crafting responsive front-ends to designing scalable back-ends and
          managing complex databases.
          <br />
          <br />
          I strive to build on my vision of creating seamless and efficient
          digital infrastructures. I specialize in turning complex data problems
          into simple, powerful solutions.
        </TextContent>
        <ProfileButton 
          href="https://vimal-portfolio.pages.dev" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Visit Portfolio
        </ProfileButton>
      </Left>
      <Right>
        <img src={img1} alt="Vimalraj" />
        
        <img
          data-scroll
          data-scroll-speed="-2"
          src={img3}
          alt="Vimalraj" 
          className="small-img-2"
        />
      </Right>
    </Section>
  );
};

export default VIMAL;